export default ( guid: string, width?: number, height?: number ) => {

    const w = width ? `width=${ width }` : "";
    const h = height ? `height=${ height }` : "";

    return `${ process.env.REACT_APP_API_URL }/files/${ guid }/thumb?${ w }&${ h }`; 
} 